var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6743 6.5838V13.3763C17.6743 15.893 16.0993 17.668 13.5827 17.668H6.37435C3.85768 17.668 2.29102 15.893 2.29102 13.3763V6.5838C2.29102 4.06714 3.86602 2.29297 6.37435 2.29297H13.5827C16.0993 2.29297 17.6743 4.06714 17.6743 6.5838Z",
    stroke: "#475467",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 13.6939L5.67372 12.3497C6.11622 11.8806 6.85372 11.8581 7.32372 12.2997C7.33789 12.3139 8.10456 13.0931 8.10456 13.0931C8.56706 13.5639 9.32289 13.5714 9.79372 13.1097C9.82456 13.0797 11.7387 10.7581 11.7387 10.7581C12.2321 10.1589 13.1179 10.0731 13.7179 10.5672C13.7579 10.6006 15.5662 12.4564 15.5662 12.4564",
    stroke: "#475467",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59326 7.61206C8.59326 8.41956 7.93909 9.07372 7.13159 9.07372C6.32409 9.07372 5.66992 8.41956 5.66992 7.61206C5.66992 6.80456 6.32409 6.15039 7.13159 6.15039C7.93909 6.15122 8.59326 6.80456 8.59326 7.61206Z",
    stroke: "#475467",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.22576f1a9495ef7d47e49dcb9d556b5a.svg";
export { ForwardRef as ReactComponent };